import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { makeStyles } from '@material-ui/core/styles';

export const VF1Logo: React.FC<SvgIconProps> = props => {
  const useStyles = makeStyles({
    cls1: { fill: '#fff', fillRule: 'evenodd' },
    cls2: { fill: '#13a9a6', fillRule: 'evenodd' },
    cls3: { fill: '#71ba31', fillRule: 'evenodd' },
    cls4: { fill: '#117d55', fillRule: 'evenodd' },
    cls5: { fill: '#146f9b', fillRule: 'evenodd' },
    cls6: { fill: '#05a8e7', fillRule: 'evenodd' },
    cls7: { fill: '#1a83bc', fillRule: 'evenodd' },
    cls8: { fill: '#0d78a1', fillRule: 'evenodd' },
    cls9: { fill: '#064b80', fillRule: 'evenodd' },
    cls10: { fill: '#07538e', fillRule: 'evenodd' },
    cls11: { fill: '#23a352', fillRule: 'evenodd' }
  });

  const classes = useStyles();

  return (
    <SvgIcon
      viewBox="0 0 468.411 56.786"
      style={{
        height: 25,
        width: 196
      }}
      {...props}
    >
      <g id="Layer_2" data-name="Layer 2">
        <path
          className={classes.cls1}
          d="M37.828,55.616H48.133l8.836,28.036,8.76-28.036h9.928l-13.292,37.7H51.119l-13.291-37.7Zm287.65,2.552a.654.654,0,0,0,.725-.624c0-.318-.19-.572-.763-.572h-.713v1.2Zm-1.4-1.794h1.376c1.017,0,1.4.547,1.4,1.183a1.09,1.09,0,0,1-.674,1.068c.19.382.535,1.134.725,1.516h-.725c-.165-.358-.457-1.031-.624-1.389h-.827v1.389h-.649V56.374Zm4.276,1.933a2.974,2.974,0,1,1-2.977-3.117,2.935,2.935,0,0,1,2.977,3.117Zm-6.628,0a3.658,3.658,0,1,1,3.651,3.716,3.574,3.574,0,0,1-3.651-3.716Zm-99.447-2.691h5.253l3.021,7.08c2.794-4.978,6.891-7.411,12.555-7.411a11.7,11.7,0,0,1,2.624.163v8.931a13.514,13.514,0,0,0-3.4-.439c-8.76,0-11.177,5.564-11.177,15.3V93.316h-8.878v-37.7Zm-106.85,0h5.252L123.7,62.7c2.8-4.978,6.891-7.411,12.555-7.411a11.7,11.7,0,0,1,2.625.163v8.931a13.514,13.514,0,0,0-3.4-.439c-8.761,0-11.178,5.564-11.178,15.3V93.316h-8.877v-37.7Zm187.977,6.331c-5.362,0-8.156,3.953-8.534,8.487h17.26c-.679-5.559-3.968-8.487-8.726-8.487ZM294.8,77.027c.225,6.369,3.323,10.177,9.062,10.177a7.509,7.509,0,0,0,7.7-5.565h9.365c-2.114,8.418-8.383,12.738-17.294,12.738-11.555,0-18.579-7.98-18.579-19.912,0-11.64,7.552-19.838,18.427-19.838,11.555,0,17.5,8.383,17.882,19.875.017,1.275-.034,1.7-.051,2.525ZM93.544,61.947c-5.362,0-8.156,3.953-8.534,8.487h17.262c-.681-5.559-3.97-8.487-8.728-8.487Zm-8.609,15.08H111.45c.018-.823.068-1.25.051-2.525-.377-11.492-6.326-19.875-17.881-19.875-10.875,0-18.428,8.2-18.428,19.838,0,11.932,7.025,19.912,18.579,19.912,8.911,0,15.18-4.32,17.3-12.738H101.7A7.508,7.508,0,0,1,94,87.2c-5.74,0-8.836-3.808-9.063-10.177ZM282.49,79.113c-1.284,9.664-7.552,15.374-17.143,15.374-11.1,0-18.125-8.051-18.125-19.693,0-11.784,6.8-20.277,18.2-20.277,8.987,0,16.01,4.759,16.841,14.421H272.9c-.529-4.319-3.248-6.808-7.25-6.808-6.042,0-8.61,5.637-8.61,12.664,0,6.591,2.644,12.08,8.308,12.08,4.3,0,7.1-2.928,7.778-7.761Zm-83.218,7.614c5.738,0,8.986-4.978,8.986-12.3,0-7.247-3.248-12.371-8.986-12.371-5.589,0-8.836,5.052-8.836,12.3,0,7.32,3.17,12.371,8.836,12.371Zm.074-32.21c11.405,0,18.655,8.2,18.655,19.911,0,11.86-7.1,19.913-18.655,19.913s-18.729-8.053-18.729-19.913c0-11.785,7.25-19.911,18.729-19.911Zm-37.455,8.345h-6.344V55.616h6.344c.075-1.1.075-2.2.151-3.223.377-7.686,3.928-11.639,12.461-11.639a34.531,34.531,0,0,1,5.362.44v7.393a14.041,14.041,0,0,0-3.323-.366c-4,0-4.682,2.05-4.682,7.4h7.552v7.246H171.86V93.316h-9.969V62.862Zm-19.257-7.246h10.044v37.7H142.634v-37.7ZM152.678,50.2H142.634V41.267h10.044Z"
          transform="translate(-37.828 -37.701)"
        />
      </g>
      <g id="Layer_3" data-name="Layer 3">
        <path
          className={classes.cls2}
          d="M366.472,45.812c-.445-2.453,1.41-5.2,5.139-8.064-16.34.834-28.117,12.6-28.117,28.291a28.583,28.583,0,0,0,2.432,11.708c1.608-.078.66.729,2.309.628,2.881-.176,8.4-1.289,11.4-1.539a18.159,18.159,0,0,1-3.307-10.8c0-8.662,5.092-15.047,12.438-16.95A5.357,5.357,0,0,1,366.472,45.812Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls3}
          d="M368.771,49.089a18.766,18.766,0,0,1,4.706-.585,16.94,16.94,0,0,1,12.489,5.118c2.47.218,6.863,3.6,9.7,3.664,2.22.053,2.821-3.177,5.243-3.217-4.548-9.91-14.789-16.368-27.435-16.368q-.943,0-1.866.047A30.273,30.273,0,0,0,351.35,46.4a95.455,95.455,0,0,0,13.4,4.3A16.806,16.806,0,0,1,368.771,49.089Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls4}
          d="M385.966,53.622a17.7,17.7,0,0,1,4.654,12.417,21.08,21.08,0,0,1-.111,2.185c2.077-.679,3.855,1.02,5.831.328,2.334-.816,4.846-4.028,7.03-4.858a28.124,28.124,0,0,0-2.458-9.625A144.609,144.609,0,0,1,385.966,53.622Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls5}
          d="M403.37,63.694c-4.032,1.534-8.329,3.048-12.861,4.53a18.579,18.579,0,0,1-1.288,5.187c2.336-.342,4.261,1.239,6.634.861,2.228-.356,4.9-2.67,7.161-3.059a29.948,29.948,0,0,0,.443-5.174Q403.459,64.851,403.37,63.694Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls6}
          d="M403.016,71.213q-6.99,1.2-13.8,2.2c-2.582,6.256-8.5,10.163-15.744,10.163a16.72,16.72,0,0,1-13.8-6.685c-3.133.755-7.3,1.06-10.541,1.773-1.052.23-1.138.891-2.2,1.118a27.475,27.475,0,0,0,12.43,11.552c5.34-2.124,12.278-1.414,18.576-3.445,7.416-2.392,14.363-7.5,22.869-9.664A27.641,27.641,0,0,0,403.016,71.213Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls5}
          d="M359.64,76.836q-5.595.467-10.915.764-1.41.08-2.8.147.465,1.041,1.013,2.033,6.512-1.389,12.741-2.891Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls5}
          d="M400.813,78.223a342.438,342.438,0,0,0-41.445,13.109,32.871,32.871,0,0,0,14.109,3.045C386.032,94.377,396.216,88.012,400.813,78.223Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls7}
          d="M463.81,42.679v6.138h10.933c3.471-1.381,8.03-1.156,11.065-2.552,4.355-2,6.948-5.631,10.308-7.625H477.227c-2.034.676-6.513.159-8.685.814C466.245,40.147,466.247,42.015,463.81,42.679Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls6}
          d="M463.81,42.679c4.741-1.293,9.231-2.646,13.417-4.039H463.81v4.039Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls8}
          d="M496.116,38.64a154.715,154.715,0,0,1-21.373,10.177h30.479V38.64h-9.106Z"
          transform="translate(-37.828 -37.701)"
        />
        <polygon
          className={classes.cls9}
          points="461.577 23.015 438.585 23.015 428.432 23.015 425.982 23.015 425.982 25.465 425.982 27.41 430.942 29.685 464.027 25.905 464.027 25.465 464.027 23.015 461.577 23.015"
        />
        <path
          className={classes.cls5}
          d="M501.855,63.606a320.011,320.011,0,0,0-38.045,1.505v5.116c2.45.352,8.023-.563,14.39-1.717s17.264-1.519,23.655-4.554Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls7}
          d="M501.855,63.956c-8.114.949-19.013,2.645-25.38,3.8s-8.833,1.665-12.665,2.472v.352h38.045V63.956Z"
          transform="translate(-37.828 -37.701)"
        />
        <polygon
          className={classes.cls6}
          points="465.961 45.56 438.585 45.56 428.432 45.56 425.982 45.56 425.982 48.01 425.982 53.287 425.982 55.737 428.432 55.737 465.961 55.737 468.411 55.737 468.411 53.287 468.411 48.01 468.411 45.56 465.961 45.56"
        />
        <path
          className={classes.cls10}
          d="M408.069,75.3V90.988c0,.074,0,.147.01.22,2.24-1.251,4.957.619,7.695-.633,1.6-.732,3.027-3.62,4.821-5.317V72.63c-1.77-2.4-4.146-2.008-6.26-1.558C412.275,71.511,410.088,74.839,408.069,75.3Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls3}
          d="M408.069,53.528c4.8-.336,10.177,1.227,15.416.586,1.5-.924,2.558-3.893,3.811-4.8L418.535,38.64H408.069V53.528Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls11}
          d="M423.162,52.065c-5.239.64-10.29,1.127-15.093,1.463V59.77c2.766-1.209,5.679-.05,8.079-1.263C418.839,57.147,420.968,53.415,423.162,52.065Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls2}
          d="M427.3,49.309q-1.879,1.368-4.134,2.756c1.3-.159,2.6,1.345,3.921,1.168.613-.082,1.231-1.839,1.85-1.925Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls10}
          d="M428.933,51.308q-2.921.408-5.771.757a123.818,123.818,0,0,1-15.093,7.705V69.4c0,2.043,4.738.124,7.282-.4,1.616-.333,4.059-.1,5.244-2.148V60.168l4.326,5.267.017.022.3.368c1.839-.414,4.524.783,6.328.356,2.557-.606,6.211-.121,6.7-3.471Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls9}
          d="M438.268,62.71q-6.352,1.61-13.027,3.115l4.2,5.116c.131-.024.511.451.641.428,5.013-.909,9.6-.726,14.43-1.034l-1.391-1.7L441.456,66.6l-3.188-3.893Zm7.534,7.518q.565-.058,1.131-.141c3.8-.557,7.8.515,11.394-3.566v-9.4c-2.168.662-3.949-.84-6.2-.2-1.934.555-4.33,3.261-6.323,3.8v9.5Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls5}
          d="M445.8,48.527v12.2q6.472-1.758,12.525-3.607V45.92c-2.124.483-4.073-2.791-6.263-2.337C450.072,44,447.843,48.14,445.8,48.527Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls2}
          d="M445.8,48.527c4.285-.812,8.469-1.685,12.525-2.607V38.64H445.8v9.887Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls5}
          d="M458.327,90.988V73.244c-2.614-4.6-8.641-.877-11.646-.043-4.4,1.222-6.245,4.97-10.237,6.267l10.369,12.626,1.116,1.344h10.4Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls10}
          d="M436.444,79.468c6.716-2.183,14.06-4.278,21.883-6.224V66.521q-6.151.757-12.525,1.708V71.91l-1.289-1.575-1.391-1.7h0l-.271.043q-6.423,1-13.017,2.191l-.392.071Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls9}
          d="M420.6,90.988v-5.73q-2.066.855-3.989,1.715c-3.151,1.409-6,2.826-8.527,4.235l-.01,2.23H420.6Z"
          transform="translate(-37.828 -37.701)"
        />
        <path
          className={classes.cls5}
          d="M408.069,75.3q6.137-1.389,12.526-2.666V67.012c0-.055,0-.11,0-.164q-6.156,1.328-12.531,2.548Z"
          transform="translate(-37.828 -37.701)"
        />
      </g>
    </SvgIcon>
  );
};
